// IUnorderedArrivalResponseからIUnorderedArrivalResultへの変換を行う
import { GetOrderResponseResult } from '@/coreInfrastructureModule/axios/generated/orderManage/api';
import { findOrderStatusOrNull } from '@/coreDomainsModule/entities/arrival';
import { Order } from '@/coreDomainsModule/entities/order';
import { INotExportedOrderResult } from '../domains/entities/INotExportedOrderResult';
import { OrderFactory } from '@/coreDomainsModule/factories/orderFactory';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 *　repositoryの型をUI用に変換する
 */
export class NotExportedOrderAdapter {
  /**
   * apiのレスポンスをUI表示用に変換する
   * @param response - apiのレスポンス
   */
  public static adapt = (response: GetOrderResponseResult): INotExportedOrderResult => {
    const firmOrderBusiness: Order[] = [];
    const pagingOptions = response.pagingOptions;
    // 未出力の発注情報のみを取得
    response.data
      ?.filter((business) => !business.outputDate)
      ?.forEach((business) => {
        firmOrderBusiness.push(
          OrderFactory.create({
            orderId: business.orderId,
            aggregateBusinessId: business.aggregateBusinessId,
            supplierNumber: business.supplierNumber,
            supplierName: business.supplierName,
            businessNumber: business.businessNumber,
            businessName: business.businessName,
            package: business.package,
            unit: business.unit,
            manufacturer: business.manufacturer,
            warehouseNumber: business.warehouseNumber,
            warehouse: business.warehouse,
            purchaseUnitPrice: business.purchaseUnitPrice != null ? Number(business.purchaseUnitPrice) : undefined,
            aggregateBusinessResponsibleUsers: business.aggregateBusinessResponsibleUsers?.map((user) =>
              UserAccountFactory.create({
                email: user.id,
                name: user.name,
                organizationId: undefined,
                role: undefined,
                profile: undefined,
                createdAt: undefined,
                updatedAt: undefined,
              })
            ),
            orderIssuedNumber: business.orderIssuedNumber,
            orderNumber: business.orderNumber,
            createdOrderDate: business.createdOrderDate,
            desiredDeliveryDate: business.desiredDeliveryDate,
            estimatedTimeOfArrival: business.estimatedTimeOfArrival,
            orderAmount: business.orderAmount,
            orderStatus: findOrderStatusOrNull(business.orderStatus) ?? 'Unknown',
            outputDate: business.outputDate,
            userCustomParameters: business.userCustomParameters,
            businessFreeColumnValues: business.businessFreeColumnValues?.map((column) => ({ ...column, target: column.target })) ?? [],
            orderAlert: [],
            orderNote: business.orderNote,
            // NOTE: 発注グループが1件しかこない想定
            orderGroupId: business.orderGroupList[0]?.orderGroupId,
            orderGroupName: business.orderGroupList[0]?.orderGroupName,
            invoiceNumber: business.orderGroupList[0]?.invoiceNumber,
            destinationName: business.orderGroupList[0]?.destinationName,
            upperLimitQuantity: business.orderGroupList[0]?.upperLimitQuantity,
          })
        );
      });
    return {
      result: firmOrderBusiness,
      pagingOptions: { ...pagingOptions },
    };
  };
}
